import { SiteManagementLocationFragment } from '@occc/graphql';
import { Card } from '@occc-app/design-system';

import MpaSimulator from './components/mpa-simulator.component';

type LocationTestingDashboardProps = {
  location: SiteManagementLocationFragment;
};

const LocationTestingDashboard = ({ location }: LocationTestingDashboardProps) => {
  return (
    <Card sx={{ pt: 4, px: 2, pb: 2 }}>
      <MpaSimulator locationId={location.uuid} />
    </Card>
  );
};

export default LocationTestingDashboard;
